import { render, staticRenderFns } from "./ProjectsNew.vue?vue&type=template&id=1e68ec94"
import script from "./ProjectsNew.vue?vue&type=script&lang=ts"
export * from "./ProjectsNew.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsNew.vue?vue&type=style&index=0&id=1e68ec94&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e68ec94')) {
      api.createRecord('1e68ec94', component.options)
    } else {
      api.reload('1e68ec94', component.options)
    }
    module.hot.accept("./ProjectsNew.vue?vue&type=template&id=1e68ec94", function () {
      api.rerender('1e68ec94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/contractorDetails/ProjectsNew.vue"
export default component.exports